import React, { useCallback } from "react";
import { func, string, object } from "prop-types";
import { dropdownItemsByStatus } from "helpers/constants";
import {
  Select,
  MenuItem,
  ListItemText,
  FormControl,
  Chip,
  Box,
} from "@material-ui/core";
import { Edit as EditIcon } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import IntlMessage from "helpers/IntlMessage";
import { selectPermissions } from "redux/permission/selector";
import { connect } from "react-redux";

const useStyles = makeStyles(() => ({
  formControl: {
    width: "100%",
  },
  select: {
    fontSize: 14,
    fontWeight: 500,
    "& .MuiSelect-select": {
      paddingTop: 6,
      paddingBottom: 6,
      paddingLeft: 10,
      paddingRight: "48px !important",
      display: "flex",
      overflowX: "auto",
      scrollbarWidth: "none", // Firefox
      "&::-webkit-scrollbar": {
        display: "none", // Chrome, Safari, Edge
      },
    },
    "& .MuiSelect-icon": {
      right: 4,
      top: "50%",
      transform: "translateY(-50%)",
    },
  },
  menuItem: {
    paddingTop: 4,
    paddingBottom: 4,
    "&:hover": {
      backgroundColor: "rgb(235, 236, 240) !important",
    },
  },
  checkbox: {
    padding: 4,
    marginRight: 4,
  },
  menuPaper: {
    maxHeight: 500,
  },
}));

function DropDown({ selectedStatus, handleChangeStatus, permissionMatrix }) {
  const classes = useStyles();

  const renderValue = useCallback((selected) => {
    if (!selected && selected !== "") {
      return null;
    }
    if (selected === "") {
      return <Chip label="All" size="small" variant="outlined" />;
    }
    const item = dropdownItemsByStatus.find((i) => i.value === selected);
    const name = item ? item.name : selected;
    return (
      <Chip label={<IntlMessage id={name} />} size="small" variant="outlined" />
    );
  }, []);

  return (
    <FormControl className={classes.formControl}>
      <Select
        id="status-select"
        value={selectedStatus}
        onChange={handleChangeStatus}
        displayEmpty
        renderValue={renderValue}
        className={classes.select}
        MenuProps={{
          classes: { paper: classes.menuPaper },
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          getContentAnchorEl: null,
        }}
      >
        <MenuItem className={classes.menuItem} key="__all__" value="">
          <ListItemText primary="All" />
        </MenuItem>
        {dropdownItemsByStatus.map((stt) => (
          <MenuItem
            className={classes.menuItem}
            key={stt.value}
            value={stt.value}
          >
            <ListItemText
              primary={
                <Box display={"flex"} alignItems={"center"} gridGap={8}>
                  <IntlMessage id={stt.name} />
                  {permissionMatrix[stt.value]?.edit && (
                    <EditIcon fontSize="small" style={{ fontSize: "0.8rem" }} />
                  )}
                </Box>
              }
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

DropDown.propTypes = {
  selectedStatus: string,
  handleChangeStatus: func,
  permissionMatrix: object,
};

const mapStateToProps = () => (state) => {
  return {
    permissionMatrix: selectPermissions(state),
  };
};

export default connect(mapStateToProps, {})(DropDown);
